/**
 * name 媒体实验室服务
 * author zhang.yingyu
 * createTime 2019-04-02
 **/
"use strict";
angular.module("mediaLaboratoryServiceModule",["hotPointDetailModule"])
    .factory("mediaLaboratoryService",["$modal",function($modal){
       return {
           checkHotPointDetail: function(detailDatas, success) {
               var modalInstance = $modal.open({
                   templateUrl: "./planningCenter/mediaLaboratory/services/hotPointDetail/main_tpl.html",
                   windowClass: "hotPointDetail",
                   backdrop: false,
                   resolve: {
                       transData: function() {
                           return {
                               "detailDatas": detailDatas
                           };
                       },
                   },
                   controller: "hotPointDetailCtrl",
               });
               modalInstance.result.then(function(result) {
                   success(result);
               });
           },
       }
    }]);